import { useTranslation } from "react-i18next";
import { FillTheFieldErrorMessage, FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const AddressField: FC<Props> = ({ index, onBlur, onChange }) => {
  const { t } = useTranslation();

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FieldLayout>
      <FillTheFieldErrorMessage name={`addresses.${index}`} />
      <FormInput
        name={`addresses.${index}.addressType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput
        name={`addresses.${index}.addressStreet1`}
        placeholder={t("contactsPage.generalInfo.street", {
          number: 1,
        })}
        onBlur={handleBlur}
      />
      <FormInput
        name={`addresses.${index}.addressStreet2`}
        placeholder={t("contactsPage.generalInfo.street", {
          number: 2,
        })}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput
        name={`addresses.${index}.addressCity`}
        placeholder={t("contactsPage.generalInfo.city")}
        onBlur={handleBlur}
      />
      <FormInput
        name={`addresses.${index}.addressCountry`}
        placeholder={t("contactsPage.generalInfo.country")}
        onBlur={handleBlur}
      />
      <FormInput
        name={`addresses.${index}.addressPostalCode`}
        placeholder={t("contactsPage.generalInfo.postcode")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
    </FieldLayout>
  );
};
